import React from 'react';

const HighVoltageTest = ({ formData, updateFormData, nextStep, prevStep, currentStep, totalSteps }) => {
  // Check if model is H variant (4031H-OTI or 4031H-WTI)
  const isHModel = formData.model && (formData.model === '4031H-OTI' || formData.model === '4031H-WTI');
  
  // Check if model is one of the specified models that should not show Results column
  const shouldHideResults = formData.model && (
    formData.model === '4031-OTI' || 
    formData.model === '4031-WTI' || 
    formData.model === '4031H-OTI' || 
    formData.model === '4031H-WTI'
  );

  const handleInputChange = (field, value) => {
    updateFormData({ 
      hvTest: { ...formData.hvTest, [field]: value }
    });
  };

  const handleHModelInputChange = (index, field, value) => {
    const newHvTestH = [...(formData.hvTestH || [])];
    newHvTestH[index] = { ...newHvTestH[index], [field]: value };
    updateFormData({ hvTestH: newHvTestH });
  };

  return (
    <div className="form-section">
      <h3>High Voltage Test</h3>
      
      <div className="table-container">
        {isHModel ? (
          // Table for H models (4031H-OTI, 4031H-WTI)
          <table className="test-table">
            <thead>
              <tr>
                <th style={{ width: '50px' }}>No.</th>
                <th>EQUIPMENT USED</th>
                <th>TEST VOLTAGE</th>
                <th>DUT</th>
                <th>TEST DESCRIPTION</th>
                {!shouldHideResults && <th>RESULT</th>}
              </tr>
            </thead>
            <tbody>
              {(formData.hvTestH || []).map((test, index) => (
                <tr key={index}>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>{index + 1}</td>
                  <td>
                    <input
                      type="text"
                      value={test.equipment || ''}
                      onChange={(e) => handleHModelInputChange(index, 'equipment', e.target.value)}
                      placeholder="MICRODYNE"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={test.testVoltage || ''}
                      onChange={(e) => handleHModelInputChange(index, 'testVoltage', e.target.value)}
                      placeholder="500V AC"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={test.dut || ''}
                      onChange={(e) => handleHModelInputChange(index, 'dut', e.target.value)}
                      placeholder="OTI/WTI"
                    />
                  </td>
                  <td>
                    <textarea
                      value={test.testDescription || ''}
                      onChange={(e) => handleHModelInputChange(index, 'testDescription', e.target.value)}
                      placeholder="Test description"
                      rows="2"
                      style={{
                        width: '100%',
                        border: 'none',
                        textAlign: 'left',
                        background: 'transparent',
                        padding: '4px',
                        resize: 'vertical',
                        fontFamily: 'inherit',
                        fontSize: 'inherit',
                      }}
                    />
                  </td>
                  {!shouldHideResults && (
                    <td>
                      <select
                        value={test.result || 'pass'}
                        onChange={(e) => handleHModelInputChange(index, 'result', e.target.value)}
                      >
                        <option value="pass">pass</option>
                        <option value="fail">fail</option>
                      </select>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          // Table for standard models (4031-OTI, 4031-WTI)
          <table className="test-table">
            <thead>
              <tr>
                <th style={{ width: '50px' }}>No.</th>
                <th>Equipment Used</th>
                <th>Test Voltage</th>
                <th>Test Description</th>
                {!shouldHideResults && <th>Result</th>}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>1</td>
                <td>
                  <input
                    type="text"
                    value={formData.hvTest.equipment}
                    onChange={(e) => handleInputChange('equipment', e.target.value)}
                    placeholder="MICRODYNE"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={formData.hvTest.testVoltage}
                    onChange={(e) => handleInputChange('testVoltage', e.target.value)}
                    placeholder="2.5 KV AC, 50Hz"
                  />
                </td>
                <td>
                  <textarea
                    value={formData.hvTest.testDescription}
                    onChange={(e) => handleInputChange('testDescription', e.target.value)}
                    placeholder="All terminals to Body for 1min."
                    rows="2"
                    style={{
                      width: '100%',
                      border: 'none',
                      textAlign: 'left',
                      background: 'transparent',
                      padding: '4px',
                      resize: 'vertical',
                      fontFamily: 'inherit',
                      fontSize: 'inherit',
                    }}
                  />
                </td>
                {!shouldHideResults && (
                  <td>
                    <select
                      value={formData.hvTest.result}
                      onChange={(e) => handleInputChange('result', e.target.value)}
                    >
                      <option value="Pass">Pass</option>
                      <option value="Fail">Fail</option>
                    </select>
                  </td>
                )}
              </tr>
            </tbody>
          </table>
        )}
      </div>

      <div className="navigation-buttons">
        <button 
          className="btn btn-secondary" 
          onClick={prevStep}
          disabled={currentStep === 1}
        >
          Previous
        </button>
        <button 
          className="btn btn-primary" 
          onClick={nextStep}
          disabled={currentStep === totalSteps}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default HighVoltageTest;
